module.exports = __webpack_public_path__ + "static/media/total-vertical-icon.a90c101a.svg";